export default {
    name: 'q-logo',
    props: {
        classes: {
            type: String,
            default: ''
        },
        href: {
            type: String,
            default: '/'
        },
        target: {
            type: String,
            default: '_self'
        }
    }
};
